<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useDisciplineBalancesStore } from '../model/balances/store'
import { abortDisciplineBalancesApi, useDisciplineBalancesApi } from '../api/balances.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import TableDisciplineBalances from './TableDisciplineBalances.vue'
import ModalDisciplineBalance from './modals/ModalDisciplineBalance.vue'

defineOptions({
  name: 'DisciplineBalancesPage',
})

const route = useRoute()
const store = useDisciplineBalancesStore()

/** The first list read shares the page loader with the discipline, so the tab appears with its rows in place; a
 *  Search or a page change keeps the rows and only locks the controls. */
const refIsFirstLoad = computed<boolean>(() => store.isLoading && store.getMeta === null)

const fetchBalances = (): void => {
  void useDisciplineBalancesApi({ disciplineId: route.params.id as string })
}

onMounted(fetchBalances)

// Filters and pagination navigate by query; the middleware has already written them to the store.
watch(() => route.query, () => {
  if (route.name === 'disciplines-id-balances') fetchBalances()
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(fetchBalances)

onBeforeUnmount(() => {
  abortDisciplineBalancesApi()
  store.setModalOpen(false)
  store.resetList()
})
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <TableDisciplineBalances />
  <ModalDisciplineBalance />
</template>
